import type { Provider } from '@angular/core';

import { repositoryFactoryBuilder } from '@contexts/shared/infrastructure/repository-factory/repository-factory';
import {
	createUserBuilder,
	deleteUserBuilder,
	findAllUsersBuilder,
	getLoggedUserBuilder,
	resendActivationCodeBuilder,
	updateApiKeyAccessBuilder,
	updateLastAlertsCheckBuilder,
	updateUserBuilder
} from '@contexts/users/application';
import type { UserRepository } from '@contexts/users/domain';

import {
	CREATE_USER_USE_CASE,
	DELETE_USER_USE_CASE,
	FIND_ALL_USERS_USE_CASE,
	GET_LOGGED_USER_USE_CASE,
	RESEND_ACTIVATION_CODE_USE_CASE,
	UPDATE_API_KEY_ACCESS_USE_CASE,
	UPDATE_LAST_ALERTS_CHECK_USE_CASE,
	UPDATE_USER_USE_CASE
} from '@dependencies/users/application/use-cases';
import { USER_REPOSITORY } from '@dependencies/users/domain/contracts';
import { USER_REPOSITORY_DEFINITION } from '@dependencies/users/infrastructure';

export const userDependencies: Provider[] = [
	repositoryFactoryBuilder<UserRepository>('users', USER_REPOSITORY, USER_REPOSITORY_DEFINITION),
	{
		provide: FIND_ALL_USERS_USE_CASE,
		useFactory: findAllUsersBuilder,
		deps: [USER_REPOSITORY]
	},
	{
		provide: CREATE_USER_USE_CASE,
		useFactory: createUserBuilder,
		deps: [USER_REPOSITORY]
	},
	{
		provide: UPDATE_USER_USE_CASE,
		useFactory: updateUserBuilder,
		deps: [USER_REPOSITORY]
	},
	{
		provide: DELETE_USER_USE_CASE,
		useFactory: deleteUserBuilder,
		deps: [USER_REPOSITORY]
	},
	{
		provide: GET_LOGGED_USER_USE_CASE,
		useFactory: getLoggedUserBuilder,
		deps: [USER_REPOSITORY]
	},
	{
		provide: RESEND_ACTIVATION_CODE_USE_CASE,
		useFactory: resendActivationCodeBuilder,
		deps: [USER_REPOSITORY]
	},
	{
		provide: UPDATE_API_KEY_ACCESS_USE_CASE,
		useFactory: updateApiKeyAccessBuilder,
		deps: [USER_REPOSITORY]
	},
	{
		provide: UPDATE_LAST_ALERTS_CHECK_USE_CASE,
		useFactory: updateLastAlertsCheckBuilder,
		deps: [USER_REPOSITORY]
	}
];

export * from '@dependencies/users/application/use-cases';
export * from '@dependencies/users/domain/contracts';
